import {
  type CMSData,
  type CMSPageDataWithSpecificLayout,
} from '@/features/cms/components/CMS/types'

/**
 * Type guard to check if CMSData is a PageLayout with body section
 * @param cmsData - The CMS data to check
 * @returns True if the data is a PageLayout with body and not an error
 */
export const isPageLayoutWithBody = (
  cmsData?: CMSData,
): cmsData is CMSPageDataWithSpecificLayout<'page_layout'> => {
  return Boolean(
    cmsData && !('error' in cmsData) && cmsData.content.data && 'body' in cmsData.content.data,
  )
}

/**
 * Type guard to check if CMSData is a PageLayout with seo_metadata section
 * @param cmsData - The CMS data to check
 * @returns True if the data is a PageLayout with seo_metadata and not an error
 */
export const isPageLayoutWithSeoMetadata = (
  cmsData?: CMSData,
): cmsData is CMSPageDataWithSpecificLayout<'page_layout'> => {
  return Boolean(
    cmsData &&
    !('error' in cmsData) &&
    cmsData.content.data &&
    'seo_metadata' in cmsData.content.data,
  )
}
